import React from 'react';
import PropTypes from 'prop-types';

import CriteriumLocalDirectory from '@hydra/common/criterium/CriteriumLocalDirectory';
import Criterium from '@hydra/common/criterium/Criterium';
import Translate from '@hydra/common/components/i18n';
import ReviewCriteriaCTA from '@hydra/common/components/CTA/ReviewCriteriaCTA';
import { useReviewContext } from '@hydra/common/context/review';

const LOCAL_DIRECTORIES = ['GoogleMyBusiness', 'Yelp'];

export const LocalDirectories = ({ criterium, url }) => {
  const { isFree, isPdf } = useReviewContext();
  if (isFree) {
    return (
      <Criterium criterium={{ type: 'local_directories', score: null, importance: 0, solvability: 0 }} clickable={false} align='center'>
        <ReviewCriteriaCTA
          text={<Translate component='div' content='local_directories_cta_text' with={{ domain: url }} />}
          event='local'
        />
      </Criterium>
    );
  }

  const { data } = criterium;

  const content = (
    <>
      {
        LOCAL_DIRECTORIES.map(directory => (
          <div key={directory}>
            <CriteriumLocalDirectory
              directory={directory}
              data={data[directory]}
              canChangeAccount={!isPdf}
            />
          </div>
        ))
      }
    </>
  );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

LocalDirectories.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      GooglePlaces: PropTypes.object,
      Yelp: PropTypes.object
    })
  })
};

export default React.memo(LocalDirectories);
